/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import s from './ServicesFooter.scss';

class DistrictDetails extends React.Component {
  render() {
    return (
      <div style={{ display: 'flex' }}>
        {this.props.districts && Object.keys(this.props.districts)
          .filter(urzad => urzad === this.props.prefix)
          .map((urzad, index) => (
            <div className="display-container" key={index} style={{ ...this.props.style }}>
              <h4>{this.props.districts[urzad].name}</h4>
              <div>
                {this.props.districts[urzad].street ? this.props.districts[urzad].street : this.props.districts[urzad].place}
                {this.props.districts[urzad].nrBuilding.length !== 0
                  ? ` ${this.props.districts[urzad].nrBuilding}`
                  : null}
                {this.props.districts[urzad].nrLocal && this.props.districts[urzad].nrLocal.length !== 0
                  ? `/${this.props.districts[urzad].nrLocal}`
                  : null}
              </div>
              <div>
                {`${this.props.districts[urzad].zipCode} ${this.props.districts[urzad].place}`}
              </div>
              <div>
                tel.: {this.props.districts[urzad].phone}
              </div>
              <div>
                faks: {this.props.districts[urzad].fax}
              </div>
              <div>{this.props.districts[urzad].email}</div>
            </div>
          ))}
      </div>
    );
  }
}

const mapState = (state) => ({
  districts: state.district.districts
});

const mapDispatch = {
};

export default withStyles(s)(connect(mapState, mapDispatch)(DistrictDetails));




// WEBPACK FOOTER //
// src/components/ServicesFooter/DistrictDetails.js